<template>
  <div class="full-screen">
    <router-view></router-view>
  </div>
</template>

<script>
    import Home from '@/pages/layer1/home'
    import Category from '@/pages/layer1/category'
    import Vod from '@/pages/layer1/vod'
    import Shelf from '@/pages/layer1/shelf'
    import User from '@/pages/layer1/user'
    import Bottom from '@/components/layer1/bottomIndex'

    export default {
        name: "layer1",
        data() {
            return {
                transitionName: 'left'
            }
        },
        components: {
            home: Home,
            category: Category,
            vod: Vod,
            shelf: Shelf,
            user: User,
            bottom: Bottom
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/layer1/index.vue